module.exports = __webpack_public_path__ + "img/mtx1.85b1b21c.jpg";